module.exports = __webpack_public_path__ + "img/pop-bg.cd632a48.png";